import { c as _c } from "react/compiler-runtime";
import PopupComponent, { PopupContext, PopupType } from '@spa/components/popup/popup.component';
import React, { Dispatch, ReactNode, useEffect, useRef } from 'react';
import AddWishlistComponent from '@spa/components/wishlist/add-wishlist/add-wishlist.component';
import { DeleteMyWishlistInAddProductPayload } from '@spa/lib/store/wishlists/wishlistsSlice';
import ImageComponent from '@spa/components/image-component/image.component';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { StateWishlist } from '@spa/lib/store/wishlists/WishlistsState';
import { WishlistTrackingProduct } from '@spa/lib/tracking/productsToAnalyticsItemConverter';
import { WishlistsActionsOriginType } from '@spa/lib/tracking/trackWishlistsActions';
import classNames from 'clsx';
import { createPortal } from 'react-dom';
import { maxNonDefaultWishlists } from '@spa/lib/const';
import selectDefaultWishlist from '@spa/lib/store/wishlists/selectors/selectDefaultWishlist';
import selectWishlists from '@spa/lib/store/wishlists/selectors/selectWishlists';
import styles from './wishlist-menu.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
import { useSelector } from 'react-redux';
export interface Props {
  readonly closeWishlistWithDelay: () => void;
  readonly deleteWishlistPayload?: DeleteMyWishlistInAddProductPayload;
  readonly disabled: boolean;
  readonly onListItemClick: (itemId: string, isDefault: boolean) => void;
  readonly origin?: WishlistsActionsOriginType;
  readonly product?: WishlistTrackingProduct;
  readonly selectedIdx: number;
  readonly setShowAddWishlistPopup: Dispatch<React.SetStateAction<boolean>>;
  readonly showAddWishlistPopup: boolean;
}
function WishlistMenuComponent(t0) {
  const $ = _c(43);
  const {
    closeWishlistWithDelay,
    deleteWishlistPayload,
    disabled,
    onListItemClick,
    origin,
    product,
    selectedIdx,
    showAddWishlistPopup,
    setShowAddWishlistPopup
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("wishlist-menu");
  const wishlists = useSelector(selectWishlists);
  const defaultWishlist = useSelector(selectDefaultWishlist);
  let t1;
  if ($[0] !== selectedIdx) {
    t1 = itemIdx => classNames({
      [styles["wishlist-menu__list-button"]]: true,
      [styles["wishlist-menu__list-button--selected"]]: itemIdx === selectedIdx
    });
    $[0] = selectedIdx;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const listItemButtonClass = t1;
  const menuRef = useRef(null);
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      if (menuRef.current) {
        menuRef.current?.focus();
      }
    };
    t3 = [menuRef];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] !== formatMessage) {
    t4 = formatMessage("title");
    $[4] = formatMessage;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== formatMessage) {
    t5 = formatMessage("title");
    $[6] = formatMessage;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t5) {
    t6 = <span>{t5}</span>;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== disabled || $[11] !== formatMessage || $[12] !== listItemButtonClass || $[13] !== onListItemClick || $[14] !== selectedIdx || $[15] !== wishlists) {
    let t8;
    if ($[17] !== disabled || $[18] !== formatMessage || $[19] !== listItemButtonClass || $[20] !== onListItemClick || $[21] !== selectedIdx) {
      t8 = (t9, itemIdx_0) => {
        const {
          id,
          name,
          isDefault
        } = t9;
        return <li key={id} className={styles["wishlist-menu__list-name"]}><button tabIndex={itemIdx_0 + 1} className={listItemButtonClass(itemIdx_0)} onClick={() => onListItemClick(id, isDefault)} disabled={disabled}>{itemIdx_0 === selectedIdx && <ImageComponent src="/assets/icons/check.svg" alt="" width={24} height={24} />}<span aria-label={itemIdx_0 === selectedIdx ? formatMessage("isSelected", {
              name
            }) : name}>{name}</span></button></li>;
      };
      $[17] = disabled;
      $[18] = formatMessage;
      $[19] = listItemButtonClass;
      $[20] = onListItemClick;
      $[21] = selectedIdx;
      $[22] = t8;
    } else {
      t8 = $[22];
    }
    t7 = wishlists.map(t8);
    $[10] = disabled;
    $[11] = formatMessage;
    $[12] = listItemButtonClass;
    $[13] = onListItemClick;
    $[14] = selectedIdx;
    $[15] = wishlists;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[23] !== t7) {
    t8 = <ul className={styles["wishlist-menu__list-names"]}>{t7}</ul>;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== defaultWishlist || $[26] !== formatMessage || $[27] !== setShowAddWishlistPopup || $[28] !== wishlists.length) {
    t9 = wishlists.length < (defaultWishlist ? maxNonDefaultWishlists + 1 : maxNonDefaultWishlists) && <button className={styles["wishlist-menu__list-create-button"]} tabIndex={wishlists.length + 1} onClick={() => {
      setShowAddWishlistPopup(true);
    }}><ImageComponent src="/assets/icons/add.svg" alt="+" width={24} height={24} /><span>{formatMessage("createNewWishlist")}</span></button>;
    $[25] = defaultWishlist;
    $[26] = formatMessage;
    $[27] = setShowAddWishlistPopup;
    $[28] = wishlists.length;
    $[29] = t9;
  } else {
    t9 = $[29];
  }
  let t10;
  if ($[30] !== closeWishlistWithDelay || $[31] !== deleteWishlistPayload || $[32] !== origin || $[33] !== product || $[34] !== setShowAddWishlistPopup || $[35] !== showAddWishlistPopup) {
    t10 = showAddWishlistPopup && createPortal(<PopupComponent focusDialogOnOpen={true} isOpen={showAddWishlistPopup} onClosed={() => {
      setShowAddWishlistPopup(false);
      closeWishlistWithDelay();
    }} popupContext={PopupContext.WISHLIST} popupType={PopupType.CENTER}><AddWishlistComponent deleteWishlistPayload={deleteWishlistPayload} handleCancelAction={() => {
        setShowAddWishlistPopup(false);
        closeWishlistWithDelay();
      }} origin={origin} product={product} /></PopupComponent>, document.body);
    $[30] = closeWishlistWithDelay;
    $[31] = deleteWishlistPayload;
    $[32] = origin;
    $[33] = product;
    $[34] = setShowAddWishlistPopup;
    $[35] = showAddWishlistPopup;
    $[36] = t10;
  } else {
    t10 = $[36];
  }
  let t11;
  if ($[37] !== t10 || $[38] !== t4 || $[39] !== t6 || $[40] !== t8 || $[41] !== t9) {
    t11 = <div tabIndex={-1} className={styles["wishlist-menu"]} aria-label={t4} ref={menuRef}>{t6}{t8}{t9}{t10}</div>;
    $[37] = t10;
    $[38] = t4;
    $[39] = t6;
    $[40] = t8;
    $[41] = t9;
    $[42] = t11;
  } else {
    t11 = $[42];
  }
  return t11;
}
export default WishlistMenuComponent;